import APP_ASSETS from "@/assets";
import { Link } from "react-router-dom";
import { NewOrderItem } from "./NewOrders";
import { Skeleton } from "@/components/ui/skeleton";
import { OrderDrawer } from "@/components/OrderDrawer";
import { useState } from "react";
import { useSelector } from "react-redux";
import { StateStatusEnum } from "@/enums/state-status.enum";
import { trackAmplitudeEvent } from "@/utils/amplitude";

function ArchivedOrders() {
  const ordersData = useSelector((state: any) => state.orders.data);
  const isLoading = useSelector(
    (state: any) => state.orders.status == StateStatusEnum.LOADING,
  );
  const hasFetched = useSelector(
    (state: any) => state.orders.status == StateStatusEnum.SUCCESS,
  );
  const [openedOrderId, setOpenedOrderId] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <main className="relative h-full max-h-[1200px] w-full max-w-[500px] bg-bg-tertiary">
      {/* ABSOLUTE POSITIONED TOPBAR */}
      <nav className="absolute top-0 flex h-14 w-full items-center justify-start gap-2 border-b border-primary bg-bg-tertiary p-4">
        <Link to={".."} relative="path">
          <img
            className="h-6 w-6"
            src={APP_ASSETS.ICONS.ARROW_LEFT}
            alt="img"
          />
        </Link>
        <p className="text-xl text-text-light">Archived Orders</p>
      </nav>
      {/* ABSOLUTE POSITIONED TOPBAR */}
      {/* ARCHIVED ORDERS */}
      <section className="no-scrollbar flex h-full flex-col items-start overflow-y-scroll px-4 pt-16">
        {/* HEADER */}
        <div className="flex flex-col items-start justify-center gap-2">
          <p className="text-2xl font-bold text-text-primary">
            Your Archived Orders
          </p>
          <p className="text-sm text-text-light">
            Orders which are incompleted in 24hrs or manually archived are moved
            to archived orders.
          </p>
        </div>
        {/* HEADER */}
        {/* ARCHIVED ORDERS LIST */}
        <div className="mt-4 flex w-full flex-col gap-4">
          {isLoading || !hasFetched ? (
            <div className="flex flex-col items-center justify-center gap-4">
              {Array(12)
                .fill(1)
                .map((_, idx) => (
                  <Skeleton key={idx} className="h-16 w-[90%]" />
                ))}
            </div>
          ) : (
            ordersData?.archivedOrders?.toJS()?.map((order: any, idx: any) => (
              <div
                className="hover:cursor-pointer"
                onClick={() => {
                  trackAmplitudeEvent("VIEW_ARCHIVED_ORDER_DETAILS");
                  // @ts-ignore
                  setOpenedOrderId(order.id);
                  setDrawerOpen(true);
                }}>
                <NewOrderItem key={idx} {...order} />
              </div>
            ))
          )}
        </div>
        {/* RESOLVABLE LIST */}
      </section>
      {/* ARCHIVED ORDERS */}
      {openedOrderId && (
        <OrderDrawer
          order={ordersData?.archivedOrders
            ?.toJS()
            ?.find((_: any) => _.id == openedOrderId)}
          autoOpen={drawerOpen}
          onClose={() => {
            setDrawerOpen(false);
          }}
          isLoading={isLoading}
          archived={true}
        />
      )}
    </main>
  );
}

export default ArchivedOrders;
